export const colors = {
  black: "#000000",
  blue100: "#f2f8fb",
  blue400: "#2195d0",
  blue500: "#0078b6",
  blue600: "#2c6da2",
  blue800: "#001E33",
  blue900: "#00132f",
  gray100: "#fafafa",
  gray150: "#f0f0f0",
  gray200: "#ebebeb",
  gray250: "#e1e1e1",
  gray275: "#dddddd",
  gray300: "#b3b3b3",
  gray500: "#919090",
  gray600: "#6f6f6f",
  gray650: "#414141",
  gray700: "#3c3c3c",
  gray750: "#373737",
  gray800: "#303030",
  gray850: "#2d2d2d",
  gray900: "#1e1e1e",
  green100: "#dfeddf",
  green400: "#339933",
  green450: "#386638",
  green500: "#284528",
  green600: "#224122",
  green700: "#182d18",
  neutral100: "#ecd2d2",
  orange400: "#ffa039",
  orange500: "#ff8500",
  orange600: "#ea8110",
  pink: "#ffe5e5",
  pink200: "#eebfbd",
  red400: "#e22422",
  red500: "#bd0000",
  white: "#ffffff",
  yellow: "#ffcc00",
  yellow100: "#fff7d9",
  yellow700: "#ddaf1a",
};

export const fonts = {
  family: {
    body: "Arial, sans-serif",
    display:
      "'Arial Black', -apple-system, BlinkMacSystemFont, Roboto, 'Arial Bold', Gadget, sans-serif",
    heading: "'Oswald', Arial, sans-serif",
  },
  weights: {
    bold: 700,
    normal: 400,
    heavy: 900,
    semiBold: 600,
  },
};
